const TIPO_MACRO = {
  SIMPLES: 1,
  PORTARIA: 2,
  EXPEDICAO: 3,
  AVANCADO: 4,
}

export default TIPO_MACRO
